import { useState } from "react";
import AuthImage from "../AuthImage";
import { ImageLightbox } from "../ImageLightbox";
import { openAuthFile } from "../../lib/fileOpen";
import { FileText, Image as ImageIcon } from "@phosphor-icons/react";

const isImage = (a) => (a.type || "").startsWith("image") || /\.(jpe?g|png|webp|gif)$/i.test(a.url || "");

export function AttachmentGallery({ attachments = [], emptyText = "No photos or files yet", testid = "attachment-gallery" }) {
  const [lb, setLb] = useState({ open: false, index: 0 });
  const images = attachments.filter(isImage);
  const docs = attachments.filter((a) => !isImage(a));
  if (!attachments.length) return <p className="text-xs text-muted-foreground" data-testid={`${testid}-empty`}>{emptyText}</p>;
  return (
    <div className="space-y-3" data-testid={testid}>
      {images.length > 0 && (
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
          {images.map((img, i) => (
            <button key={`${img.url}-${i}`} type="button" onClick={() => setLb({ open: true, index: i })} className="aspect-square rounded-md overflow-hidden border border-border bg-muted hover:opacity-90 transition-opacity" data-testid={`${testid}-image-${i}`}>
              <AuthImage path={img.url} alt={img.name || "photo"} className="w-full h-full object-cover" loading="lazy" />
            </button>
          ))}
        </div>
      )}
      {docs.length > 0 && (
        <ul className="divide-y divide-border border border-border rounded-md">
          {docs.map((d, i) => (
            <li key={`${d.url}-${i}`}>
              <button type="button" onClick={() => openAuthFile(d.url)} className="w-full flex items-center gap-2 px-3 py-2 text-left text-xs hover:bg-muted/40" data-testid={`${testid}-doc-${i}`}>
                <FileText size={16} className="text-primary shrink-0" />
                <span className="truncate flex-1">{d.name || "Document"}</span>
                {d.size ? <span className="text-[10px] text-muted-foreground">{Math.round(d.size / 1024)} KB</span> : null}
              </button>
            </li>
          ))}
        </ul>
      )}
      {images.length === 0 && docs.length === 0 && <p className="text-xs text-muted-foreground flex items-center gap-1"><ImageIcon size={14} /> {emptyText}</p>}
      <ImageLightbox images={images} initialIndex={lb.index} open={lb.open} onClose={() => setLb({ open: false, index: 0 })} />
    </div>
  );
}
